export const EXPIRATION_AFTER_ISSUED_MESSAGE = 'Expiration date must be after the issued date.';
//# sourceMappingURL=expiration-after-issued-message.js.map